<template>
  <div>
    <template v-if="[1, 2].indexOf(getUserRoleId) <= -1">
      <div class="db-page" id="rowListListPage">
        <template v-if="true">
          <!-- <draggable> -->
            <transition-group tag="div" type="transition" name="flip-list" class="rowList">
              <div :key="'conIndx'" class="db-widget-row">
                <!-- <draggable> -->
                  <transition-group type="transition" name="flip-list" class="db_columns_wrap doubelgrid1 medium">
                    <div :key="'conIndxconIndx'" class="db-widget-column" :class="{ 'widget-expended': widgetExpended==1 }">
                      <uscisDocumentTool @togleExpend="togleExpend" @show-details="handleShowDetails" ref="reloadList"></uscisDocumentTool>
                    </div>
                  </transition-group>
                <!-- </draggable> -->
              </div>
            </transition-group>
          <!-- </draggable> -->
          <div  class="workflow_view_wrap taskmanagement emailtemplate" :class="{ listopen: showDetailPopup }">
          <div class="workflow_overlay" @click="showDetailPopup = false;hidemodal()"></div>
          <div class="workflow_view_cnt questionary_cnt bulkemail_details" style="max-width:1200px">
            <div class="workflow_view_title view__title email_title-v2" :class="{ 'pr-0': type == 'showWorkflowview' }" >
              <span class="close" @click="showDetailPopup = false;hidemodal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="custom-class feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                <!-- <x-icon size="1.5x" class="custom-class"></x-icon> -->
              </span>
            </div>
           <div class="workflow_view_sec overflow_auto deadline-widgets-updated AItools_modal">
            <div class="altool_head">
              <span class="sub-title" v-if="!checkProperty(item,'childDocs')">{{checkProperty( showDetails,'nameNo')}}</span>
              <VuePerfectScrollbar   ref="mainSidebarPs"	
              class="scroll-area--main-sidebar scroll-head"	
              :settings="settings"	
              
          >
          <div class="widget-filters">
              <button class="filter_btn" :class="{'active':selecetedTab=='ALL'}"  @click="changeTab('ALL')"><em>All</em><span > {{ allDocsStats }} </span></button>
              <button class="filter_btn" :class="{'active':selecetedTab=='PENDING'}"  @click="changeTab('PENDING')" ><em>In Process</em><span >{{ pendingDocsStats }} </span></button>
              <button class="filter_btn" :class="{'active':selecetedTab=='COMPLETED'}"  @click="changeTab('COMPLETED')"><em>Completed</em><span >{{ completeDocsStats}} </span></button>
              <button class="filter_btn" :class="{'active':selecetedTab=='Ignored'}"  @click="changeTab('Ignored')"><em>Duplicate</em><span >{{ ignoredDocsStats}} </span></button>
              <button class="filter_btn" :class="{'active':selecetedTab=='CaseNotFound'}"  @click="changeTab('CaseNotFound')"><em>Case Not Found</em><span >{{ caseNotFoundDocsStats}} </span></button>
              <button class="filter_btn" :class="{'active':selecetedTab=='Failed'}"  @click="changeTab('Failed')"><em>Failed</em><span >{{ failedDocsStats }} </span></button>
          </div>          
          </VuePerfectScrollbar>
          <div class="search width250" >              
            <vs-input :key="'searchText'"
              icon-pack="feather"
              icon="icon-search"
              v-model="searchText"
              placeholder="Search by Name"
              class="is-label-placeholder"
            />  
          </div> 
            </div>
            
            
            <template  v-if="checkProperty(detailDocumentsList ,'length')>0&&!isListLoading" >
            <div class="missed-deadlines" v-if="checkProperty(detailDocumentsList ,'length')>0">
                <div class="widget-content uploaded_files_widget">
                    <div class="widget-deadline-list ai_details" v-for="(item ,itmIndex) in detailDocumentsList" :key="itmIndex">
                      <!-- <span class="sub-title">{{checkProperty( showDetails,'nameNo')}}</span> -->
                      <!-- <span class="sub-title" v-if="!checkProperty(item,'childDocs')">{{checkProperty( showDetails,'nameNo')}}</span> -->
                      <div class="deadline-details parent" v-if="!checkProperty(item,'childDocs')">
                        <!-- <span class="sub-title">{{checkProperty( showDetails,'nameNo')}}</span> -->
                            <!-- <docmentType :title="checkProperty(item, 'document', 'name')" :item="item['document']" /> -->
                            <div class="missed-date cursor" @click="download_or_view(checkProperty(item, 'document'))" >        
                                <docmentType :title="checkProperty(item, 'document', 'name')" :item="item['document']" />
                            </div>
                            <div class="deadline-info" @click="download_or_view(checkProperty(item, 'document'))">
                                <template  v-if="checkProperty(item, 'document', 'name')" >
                                    <p class="d-inline-block hassub"> {{checkProperty(item, 'document', 'name')}} 
                                      <!-- <span class="d-inline-block" v-if="checkProperty(item, 'caseData', 'Case Type')"> {{capitalizeFirstLetter(checkProperty(item, 'caseData', 'Case Type'))}} </span> 
                                      <span class="d-inline-block" v-if="checkProperty(item, 'caseData', 'Notice Type')"> {{capitalizeFirstLetter(checkProperty(item, 'caseData', 'Notice Type'))}} </span>
                                      <span class="d-inline-block" v-if="checkProperty(item, 'caseData', 'CaseType')"> {{ capitalizeFirstLetter(checkProperty(item, 'caseData', 'CaseType')) }}</span> 
                                      <span class="d-inline-block" v-if="checkProperty(item, 'caseData', 'NoticeType')"> {{ capitalizeFirstLetter(checkProperty(item, 'caseData', 'NoticeType')) }}</span>
                                    -->
                                          <span class="d-inline-block" v-if="checkProperty(item, 'caseData', 'Case Type')">
                                            {{ capitalizeFirstLetter(checkProperty(item, 'caseData', 'Case Type')) }}
                                          </span>
                                          <span class="d-inline-block" v-else-if="checkProperty(item, 'caseData', 'CaseType')">
                                            {{ capitalizeFirstLetter(checkProperty(item, 'caseData', 'CaseType')) }}
                                          </span>
                                          <span class="d-inline-block" v-if="checkProperty(item, 'caseData', 'Notice Type')">
                                            {{ capitalizeFirstLetter(checkProperty(item, 'caseData', 'Notice Type')) }}
                                          </span>
                                          <span class="d-inline-block" v-else-if="checkProperty(item, 'caseData', 'NoticeType')">
                                            {{ capitalizeFirstLetter(checkProperty(item, 'caseData', 'NoticeType')) }}
                                          </span>
                                    </p> 
                                    <!-- <li class="cursor">
                                      <span class="d-inline-block"> {{checkProperty(item, 'caseData', 'Notice Type')}} </span>
                                    </li> -->
                                    <!-- <ul>
                                        <li v-if="checkProperty( item,'createdOn')">
                                            <span > Uploaded On {{checkProperty( item,'createdOn') | formatDate}} </span>
                                        </li>
                                        <li v-if="checkProperty( item,'createdByName')">
                                            <span> Uploaded By {{checkProperty( item,'createdByName')}}
                                            <template v-if="checkProperty( item,'createdByRoleName')">({{checkProperty( item,'createdByRoleName')}})</template>
                                            </span>
                                        </li>
                                    </ul> -->
                                    <ul>
                                      <li class="cursor">
                                          <span>Beneficiary:
                                          <template>{{checkProperty( item,'caseData','Beneficiary')?checkProperty( item,'caseData','Beneficiary'):'N/A'}}</template></span>
                                      </li>
                                      <li class="cursor">
                                          <span>Petitioner:
                                          <template>{{checkProperty( item,'caseData','Petitioner')?checkProperty( item,'caseData','Petitioner'):'N/A'}}</template></span>
                                      </li>
                                    </ul>
                                    <ul>
                                      <!-- <li class="cursor">
                                          <span>Beneficiary:
                                          <template>{{checkProperty( item,'caseData','Beneficiary')?checkProperty( item,'caseData','Beneficiary'):'N/A'}}</template></span>
                                      </li>
                                      <li class="cursor">
                                          <span>Petitioner:
                                          <template>{{checkProperty( item,'caseData','Petitioner')?checkProperty( item,'caseData','Petitioner'):'N/A'}}</template></span>
                                      </li> -->
                                        <li class="cursor">
                                            <span > By {{checkProperty( showDetails,'createdByName')?showDetails.createdByName:'--'}}
                                              <template >({{checkProperty( showDetails,'createdByRoleName')?showDetails.createdByRoleName:'--'}}) On {{checkProperty( item,'createdOn')| formatDateTime}}</template> </span>
                                        </li>
                                        <!-- <li v-if="checkProperty( docItem,'createdOn')">
                                            <span>Created On:
                                            <template >{{checkProperty( docItem,'createdOn')| formatDateTime}}</template>
                                            </span>
                                        </li> -->
                                    </ul>
                                </template>
                            </div>
                            <div class="case__info">
                              <label v-if="checkProperty( item,'petitionDetails','caseNo')">Case No: <strong @click="redirectToCaseDetails(checkProperty( item,'petitionDetails'))">{{checkProperty( item,'petitionDetails','caseNo')}} </strong></label>
                              <p>
                                {{ checkProperty(item, 'petitionDetails', 'typeName') }}
                                <small v-if="checkProperty(item, 'petitionDetails', 'subTypeName')">({{ checkProperty(item, 'petitionDetails', 'subTypeName')}})</small>
                              </p>
                            </div>
                           <div class="d-flex align-center ml-auto">
                            <span  @click="showSearchDetails(item)" class="offcanvas-btn pl-3 pr-3 mr-4" v-if="[4,5].indexOf(checkProperty(item ,'statusId'))>-1">Search for Case</span>
                            <span class="statusspan line-none"
                            v-bind:class="{
                             'status_approved': checkProperty(item ,'statusId') == 2,
                             'status_inProcess': checkProperty(item ,'statusId') == 1,
                             'status_ready_for_filing': checkProperty(item ,'statusId') == 3,
                             'status_denied': checkProperty(item ,'statusId') == 4,
                             'status_casenotfound': checkProperty(item ,'statusId') == 5,
                            }">
                            <template v-if="checkProperty(item ,'statusId')==2">Completed</template>
                            <template v-if="checkProperty(item ,'statusId')==3">Duplicate</template>
                            <template v-if="checkProperty(item ,'statusId')==4">Failed</template>
                            <template v-if="checkProperty(item ,'statusId')==1">In Process</template>
                            <template v-if="checkProperty(item ,'statusId')==5">Case Not Found</template>
                            </span>
                           </div>
                      </div>
                      <div class="deadline-details haschild"  v-else >
                        <!-- <span class="sub-title">{{checkProperty( showDetails,'nameNo')}}</span> -->
                        <div class="deadline-details parent" >
                          <div class="missed-date cursor" @click="download_or_view(item)" >
                              <docmentType :title="checkProperty(item,  'name')" :item="item" />
                          </div>
                          <div class="deadline-info" @click="download_or_view(item)">
                              <template  v-if="checkProperty(item, 'name')" >
                                  <p class="d-inline-block"> {{checkProperty(item, 'name')}} </p>
                                  
                                  <ul>
                                      <!-- <li class="cursor">
                                          <span > By {{checkProperty( showDetails,'createdByName')?showDetails.createdByName:'--'}}
                                            <template >({{checkProperty( showDetails,'createdByRoleName')?showDetails.createdByRoleName:'--'}}) On {{checkProperty( showDetails,'createdOn')?showDetails.createdOn:''| formatDateTime}}</template> </span>
                                      </li> -->
                                      <!-- <li class="cursor">
                                          <span>Beneficiary:
                                          <template>{{checkProperty( item,'caseData','Beneficiary')?checkProperty( item,'caseData','Beneficiary'):'N/A'}}</template></span>
                                      </li>
                                      <li class="cursor">
                                          <span>Petitioner:
                                          <template>{{checkProperty( item,'caseData','Petitioner')?checkProperty( item,'caseData','Petitioner'):'N/A'}}</template></span>
                                      </li> -->
                                  </ul>
                              </template>
                          </div>
                        
                          <!-- <div class="d-flex align-center ml-auto">
                          <span class="statusspan line-none"
                          v-bind:class="{
                            'status_approved': checkProperty(item ,'statusId') == 2,
                            'status_inProcess': checkProperty(item ,'statusId') == 1,
                            'status_ready_for_filing': checkProperty(item ,'statusId') == 3,
                            'status_denied': checkProperty(item ,'statusId') == 4,
                          }">
                          <template v-if="checkProperty(item ,'statusId')==2">Completed</template>
                          <template v-if="checkProperty(item ,'statusId')==3">Ignored</template>
                          <template v-if="checkProperty(item ,'statusId')==4">Failed</template>
                          <template v-if="checkProperty(item ,'statusId')==1">In Progress</template>
                          </span>
                          </div> -->
                        </div>
                        <div :class="item.childDocs&&item.childDocs.length>0?'child_wrap':''">
                          <div class="widget-deadline-list child" v-for="(subItem ,subIndex) in item.childDocs">
                            <div class="deadline-details" >
                              <!-- <docmentType :title="checkProperty(item, 'document', 'name')" :item="item['document']" /> -->
                                <div class="missed-date cursor" @click="download_or_view(checkProperty(subItem, 'document'))" >
                                  <!-- <span>{{checkProperty( showDetails,'nameNo')}}</span> -->
                                    <docmentType :title="checkProperty(subItem, 'document', 'name')" :item="subItem['document']" />
                                </div>
                                <div class="deadline-info"   @click="download_or_view(checkProperty(subItem, 'document'))">
                                    <template  v-if="checkProperty(subItem, 'document', 'name')" >
                                        <p class="d-inline-block hassub"> {{checkProperty(subItem, 'document', 'name')}}
                                          <!-- <span class="d-inline-block" v-if="checkProperty(subItem, 'caseData', 'Case Type')"> {{capitalizeFirstLetter(checkProperty(subItem, 'caseData', 'Case Type'))}} </span> 
                                          <span class="d-inline-block" v-if="checkProperty(subItem, 'caseData', 'Notice Type')"> {{capitalizeFirstLetter(checkProperty(subItem, 'caseData', 'Notice Type'))}} </span>
                                          <span class="d-inline-block" v-if="checkProperty(subItem, 'caseData', 'CaseType')"> {{ capitalizeFirstLetter(checkProperty(subItem, 'caseData', 'CaseType')) }}</span> 
                                          <span class="d-inline-block" v-if="checkProperty(subItem, 'caseData', 'NoticeType')"> {{ capitalizeFirstLetter(checkProperty(subItem, 'caseData', 'NoticeType')) }}</span>
                                     -->
                                          <span class="d-inline-block" v-if="checkProperty(subItem, 'caseData', 'Case Type')">
                                            {{ capitalizeFirstLetter(checkProperty(subItem, 'caseData', 'Case Type')) }}
                                          </span>
                                          <span class="d-inline-block" v-else-if="checkProperty(subItem, 'caseData', 'CaseType')">
                                            {{ capitalizeFirstLetter(checkProperty(subItem, 'caseData', 'CaseType')) }}
                                          </span>
                                          <span class="d-inline-block" v-if="checkProperty(subItem, 'caseData', 'Notice Type')">
                                            {{ capitalizeFirstLetter(checkProperty(subItem, 'caseData', 'Notice Type')) }}
                                          </span>
                                          <span class="d-inline-block" v-else-if="checkProperty(subItem, 'caseData', 'NoticeType')">
                                            {{ capitalizeFirstLetter(checkProperty(subItem, 'caseData', 'NoticeType')) }}
                                          </span>
                                        </p>
                                        
                                        <!-- <ul>
                                            <li v-if="checkProperty( item,'createdOn')">
                                                <span > Uploaded On {{checkProperty( item,'createdOn') | formatDate}} </span>
                                            </li>
                                            <li v-if="checkProperty( item,'createdByName')">
                                                <span> Uploaded By {{checkProperty( item,'createdByName')}}
                                                <template v-if="checkProperty( item,'createdByRoleName')">({{checkProperty( item,'createdByRoleName')}})</template>
                                                </span>
                                            </li>
                                        </ul> -->
                                        <!-- class="cursor-default" -->
                                        <ul >
                                          <li class="cursor">
                                          <span>Beneficiary:
                                          <template>{{checkProperty( subItem,'caseData','Beneficiary')?checkProperty( subItem,'caseData','Beneficiary'):'N/A'}}</template></span>
                                      </li>
                                      <li class="cursor">
                                          <span>Petitioner:
                                          <template>{{checkProperty( subItem,'caseData','Petitioner')?checkProperty( subItem,'caseData','Petitioner'):'N/A'}}</template></span>
                                      </li>
                                            <!-- <li class="cursor">
                                                <span > By {{checkProperty( showDetails,'createdByName')?showDetails.createdByName:'--'}}
                                                  <template >({{checkProperty( showDetails,'createdByRoleName')?showDetails.createdByRoleName:'--'}}) On {{checkProperty( subItem,'createdOn')| formatDateTime}}</template> </span>
                                            </li> -->
                                            <!-- <li v-if="checkProperty( docItem,'createdOn')">
                                                <span>Created On:
                                                <template >{{checkProperty( docItem,'createdOn')| formatDateTime}}</template>
                                                </span>
                                            </li> -->
                                        </ul>
                                    </template>
                                </div>
                                <div class="case__info">
                                  <label v-if="checkProperty( subItem,'petitionDetails','caseNo')">Case No: <strong @click="redirectToCaseDetails(checkProperty( subItem,'petitionDetails'))">{{checkProperty( subItem,'petitionDetails','caseNo')}} </strong></label>
                                  <p>
                                    {{ checkProperty(subItem, 'petitionDetails', 'typeName') }}
                                    <small v-if="checkProperty(subItem, 'petitionDetails', 'subTypeName')">({{ checkProperty(subItem, 'petitionDetails', 'subTypeName')}})</small>
                                  </p>
                                </div>
                              <div class="d-flex align-center ml-auto">
                                <span  @click="showSearchDetails(subItem)" class="offcanvas-btn pl-3 pr-3 mr-4" v-if="[4,5].indexOf(checkProperty(subItem ,'statusId'))>-1">Search for Case</span>
                                <span class="statusspan line-none"
                                v-bind:class="{
                                'status_approved': checkProperty(subItem ,'statusId') == 2,
                                'status_inProcess': checkProperty(subItem ,'statusId') == 1,
                                'status_ready_for_filing': checkProperty(subItem ,'statusId') == 3,
                                'status_denied': checkProperty(subItem ,'statusId') == 4,
                                'status_casenotfound': checkProperty(subItem ,'statusId') == 5,
                                }">
                                <template v-if="checkProperty(subItem ,'statusId')==2">Completed</template>
                                <template v-if="checkProperty(subItem ,'statusId')==3">Duplicate</template>
                                <template v-if="checkProperty(subItem ,'statusId')==4">Failed</template>
                                <template v-if="checkProperty(subItem ,'statusId')==1">In Process</template>
                                <template v-if="checkProperty(subItem ,'statusId')==5">Case Not Found</template>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>  
                </div>
                <div class="table_footer">
        <div class="vx-col  con-select pages_select"  v-if="detailDocumentsList.length>0">
          <label class="typo__label">Per Page</label>
          <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false" :allow-empty="false"
              :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
              :preselect-first="true">
            </multiselect>
            <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
          </div>
      <paginate v-if="detailDocumentsList.length>0" v-model="page" :page-count="totalpages" :page-range="3" :margin-pages="2"
        :click-handler="pageNate" prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
        :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'"></paginate>
      </div>






            </div>
          </template>
          <template v-else>
           <NoDataFound
              ref="NoDataFoundRef"
              :loading="isListLoading"
              heading="No Data Found"
              type="support"
              />
          </template>
          <LinkCase
          v-if="showSearchModal" 
          @updateDetails="updateDetails" 
          @hideMe="updateDetails();showSearchModal = false"  
          :popUpTitle="'Search for Case'"
          :documentDetail="selectedCaseItem"
          
          />
          <vs-popup
      class="document_modal document_modal-v2 "
      :class="{ 'expand': expandModal, 'custom_close_doc_modal':showCloseIcon }"
      :title="checkProperty(selectedFile, 'name')"
      :active.sync="docPrivew"
    >
    <div class="document_actions" @click="expandModal = !expandModal">
      <figure v-if="!expandModal" class="maximize-img"><img src="@/assets/images/maximize.png"  width="18" height="18"/></figure>
      <figure v-else class="minimize-img"><img src="@/assets/images/minimize.png"  width="20" height="20"/></figure>
    </div>
    <div class="custom_close" v-if="showCloseIcon">
      <figure class="close_icon" @click="showConfrmLetterPopup = true;updateletterLoading = false;errorMessage=''">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20"><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z"/></svg>
      </figure>
    </div>
      <h2>
        <img
          :class="{
            pdf_view_download: docType == 'pdf',
            office_view_download: docType == 'office',
            image_view_download: docType == 'image',
          }"
          class="download-button"
          @click="downloads3file(selectedFile)"
          src="@/assets/images/download.svg"
        />
      </h2>
      <div class="pdf_loader">
        <figure v-if="formSubmited && !saveEditedFile" class="loader loader2">
          <img src="@/assets/images/main/loader.gif" />
        </figure>
        <template v-if="docType == 'office'">
          <div style="height: 90vh">
            <div id="placeholder" style="height: 100%"></div>
          </div>
        </template>
        <template v-else-if="docType == 'image'">
          <img :src="docValue" />
        </template>
        <template v-else-if="docType == 'pdf'">
          <div class="pdf" style="height: 90vh">
            <iframe
              v-if="docValue != ''"
              border="0"
              style="border: 0px"
              :src="docValue"
              height="100%"
              width="100%"
            >
            </iframe>
          </div>
        </template>
      </div>
          </vs-popup>
            <div>
            </div>
           </div>
           </div>
          </div>
         
      <!-- </div> -->

        </template>
      </div>
    </template>
  </div>
</template>
     
     
<script>
import uscisDocumentTool from "@/views/documentAiTools/uscisDocumentTool.vue";
import draggable from "vuedraggable";
import JQuery from "jquery";
import docmentType from "@/views/common/docType.vue";
import NoDataFound from "@/views/common/noData.vue";
import Paginate from "vuejs-paginate";
import LinkCase from "../documentAiTools/linkWithCase.vue";
export default {
 
  components: {
    uscisDocumentTool,
    draggable,
    docmentType,
    NoDataFound,
    Paginate,
    LinkCase
  },
  data: function () {
    return {
      showSearchModal:false,selectedCaseItem:null,
      showDetails:null,
      docType: "",
      showCloseIcon:false,
      showDetailPopup:false,
      detailDocumentsList:[],
      showToolsPopup: false,
      OverdueCaseCount: 0,
      OverdueTaskCount: 0,
      dueTodayCaseCount: 0,
      dueTodayTaskCount: 0,
      deadlineStats: null,
      widgetExpended: '',
      // editor: ClassicEditor,
      editorConfig: {
        toolbar: ['bold', 'italic', '|', 'undo', 'redo', 'NumberedList', 'BulletedList',],
      },
      listForDashboard: null,
      duplicateColumnConform: false,
      deleteColumnConform: false,
      deletedColumnData: null,
      allWidjectsFilters: [],
      tabName: 'TODO',
      selectdWidgetData: null,
 
      rowExistingColumns: [],
      selectedWidgets: null,
      selectedRowId: '',
      selectedColumnId: '',
      primary: false,
      value: null,
      options: [],
      widgetsSearchText: '',
      widgetAllCodes: [],
      tempWidgetAllCodes: [],
      maxColumnsInRow: 3,
      wedgetHights: {
 
        "1X": 'small',
        "1.5": "medium",
        "2X": "large"
 
      },
      widgetsConfigDetaiis: null,
      searchtxt: '',
      layOutRowList: [],
      editLayOutConfig: false,
      editWidgetConfig: false,
      rowData: [],
      newWedgetData: [],
      popupActivo: false,
      sectionsList: [],
      sortModel: [],
      emptyColumnData: {
 
        "rowId": "",
        "columnId": "",
        "title": "Tasks",
        "code": "TASK",
        "filters": {
          "statusIds": [],
          "createdDateRange": []
        },
        "sorting": {
          "path": "createdOn",
          "order": -1
        },
        "perpage": 5
 
 
      },
 
      sections: {
        section1: {
          title: "section1",
          order: 1,
        },
        section2: {
          title: "section2",
          order: 2,
        },
        // section3: {
        //   title: "section3",
        //   order: 3,
        // },
      },
      settings: {
        swipeEasing: true,
      },
      widgets: [
        // {
        //   section: "section1",
        // },
        {
          section: "section1",
        },
        {
          section: "section1",
        },
        {
          section: "section2",
        },
        {
          section: "section2",
        },
        // {
        //   section: "section3",
        // },
      ],
      selectedForRowDelete: -1,
      approveConformRowDelete: false,
      approveConformDuplicateRow: false,
      seletedRowForDuplicate: null,
      showPageLoading: true,
 
      /*ACTION DATA*/
      taskAccepting: false,
 
      openTaskRejectPopUp: false,
      payloadAccept: {
        "taskId": "",
        "action": "TASK_ACCEPT",//'TASK_REJECT',
        "comment": ""
      },
      error: '',
      actionColumnId: null,
      actionRowId: null,
      actionCode: null,
 
 
      //Approve Pet
      approveConformpopUp: false,
      petitioner: null,
      actionText: '',
      popupbtnTxt: '',
      selectedStatus: null,
      loading: false,
      formErrors: '',
 
      /*ACTION DATA*/

          
        showToolsPopup:false,
          popupFilter:false,
          value: null,
          options: [],
          primary:'',         
          isListLoading:true,
            selectedFileForEdit:false,
            showCloseIcon:false,
            expandModal:false,
            formSubmited:false,
            docValue: "",
            docType: "",
            selectedFile:null,
            docPrivew:false,
            perPeges: [125,150, 175, 200, 225],
            totalpages: 0,
            totalCount: 0,
            perpage: 100,
            page: 1,
            aiToolReqId:"",
            selecetedTab:'ALL',
            allDocsStats:0,
            pendingDocsStats:0,
            completeDocsStats:0,
            ignoredDocsStats:0,failedDocsStats:0,caseNotFoundDocsStats:0,
            searchText:''

    };
  },
 
  computed: {
 
    sectionWidgets() {
      return Object.keys(this.sections).reduce((acc, sectionId) => {
        acc[sectionId] = this.getWidgetsBySection(sectionId).map(
          (widget) => widget.title
        );
        return acc;
      }, {});
    },
  },
  watch: {
      
    searchText: function (value) {
      this.page = 1;
      this.getDetails(this.selecetedTab);
      //this.getStatsCount();
      },
     

    },
  methods: {
    capitalizeFirstLetter(string) {
      if (!string) return '';
      //return string.toUpperCase();
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    updateDetails(){
     // console.log("update-Details")
      this.getDetails();
      this.getStatsCount();
    },
    showSearchDetails(selectItem){
      //console.log("selectItem-selectItem",selectItem)
      if(selectItem){
        this.selectedCaseItem=selectItem
        this.showSearchModal=true
      }

    },
    hidemodal(){
      this.searchText=''
      this.selecetedTab='ALL'
      this.allDocsStats=0
      this.pendingDocsStats=0
      this.completeDocsStats=0
      this.ignoredDocsStats=0
      this.failedDocsStats=0
      this.caseNotFoundDocsStats=0
      this.$refs.reloadList.getDocumentsList();
    },
    redirectToCaseDetails(petitionDetails){
      if(petitionDetails){
        let routeId = this.checkProperty(petitionDetails, 'caseId') 
            if(this.checkProperty(petitionDetails, 'type') == 15){
                this.$router.push({ name: 'gc-employment-details', params: { itemId: routeId } }).catch(err => { })
            }else{
                this.$router.push({ name: 'petition-details', params: { itemId: routeId } }).catch(err => { })
            }

      }

    },
    handleShowDetails(item){
    //this.showDetailPopup=true
    ///console.log("parentitem",item)
    if(item){
       this.showDetails=item
    }
  
    if(this.checkProperty(item, '_id')){
      this.showDetailPopup=true
      this.detailDocumentsList=[],
      this.aiToolReqId=this.checkProperty(item, '_id')
      this.getDetails();
      this.getStatsCount();
    }
    },
    getDetails(tab = 'ALL'){
      let Payload= {
      'aiToolReqId': this.aiToolReqId,
		  "filters": {
			"title": this.searchText,
			"categoryList": ["uscis_notice"],
      "statusIdList": []
			//"statusIdList": [1,2]
		},
		"page": this.page,
		"perpage": this.perpage
      }
      if(tab == 'PENDING'){
        Payload['filters']['statusIdList'] = [1]
      }
      if(tab == 'COMPLETED'){
        Payload['filters']['statusIdList'] = [2]
      }
      if(tab == 'Ignored'){
        Payload['filters']['statusIdList'] = [3]
      }
      if(tab == 'Failed'){
        Payload['filters']['statusIdList'] = [4]
      }
      if(tab == 'CaseNotFound'){
        Payload['filters']['statusIdList'] = [5]
      }
      this.detailDocumentsList = []
      this.isListLoading = true
      this.updateLoading(true);
      this.$store.dispatch("getList", {"data":Payload ,"path":"ai-tools/cron-request-list"})
      .then(response => {
        this.isListLoading = false
        this.updateLoading(true);
        this.totalCount = this.checkProperty(response, 'totalCount');
        this.totalpages = Math.ceil(response.totalCount / this.perpage);
        setTimeout(()=>{
                    this.updateLoading(false);
                },5)
        if(this.checkProperty(response ,'list') && this.checkProperty(response ,'list','length')>0){
          let resultDocs=[]
         //this.detailDocumentsList=response.list
         this.showDetails.documents.forEach(document => {
          let responseItems = response.list.filter(item => item.reqDocumentId === document._id);

            if (responseItems.length>1) {
                let docItem = document
                docItem['childDocs'] = responseItems
                resultDocs.push(docItem)
               // console.log("responseItems",responseItems)
            }else if(responseItems.length==1){
              resultDocs.push(responseItems[0])
            }
        });
        this.detailDocumentsList=resultDocs
        }
        






      }).catch(()=>{
        this.showDetailPopup=false
      })
    },
    getStatsCount(tab = 'ALL'){
            let payLoad={
              'aiToolReqId': this.aiToolReqId,
                "filters": {
                    title:this.searchText,
                    categoryList:['uscis_notice'],
                    statusIdList:[],
                   
                },  
            };
            let path='/ai-tools/cron-request-stats'
            this.$store.dispatch("getList", { "data": payLoad, "path": path }).then((response)=>{
                if(response && response.length>0){
                    let findPenObj = _.find(response, {'statusId':1})
                    if(findPenObj && findPenObj['count'] ){
                        this.pendingDocsStats = findPenObj['count']
                    }
                    let findcomObj = _.find(response, {'statusId':2})
                    if(findcomObj && findcomObj['count'] ){
                        this.completeDocsStats = findcomObj['count']
                    }
                    let findignObj = _.find(response, {'statusId':3})
                    if(findignObj && findignObj['count'] ){
                        this.ignoredDocsStats = findignObj['count']
                    }
                    let findfaildObj = _.find(response, {'statusId':4})
                    if(findfaildObj && findfaildObj['count'] ){
                        this.failedDocsStats = findfaildObj['count']
                    }
                    let findcasenotfoundObj = _.find(response, {'statusId':5})
                    if(findcasenotfoundObj && findcasenotfoundObj['count'] ){
                        this.caseNotFoundDocsStats = findcasenotfoundObj['count']
                    }
                    if(this.completeDocsStats > 0 || this.pendingDocsStats > 0||this.ignoredDocsStats > 0||this.failedDocsStats > 0||this.caseNotFoundDocsStats >0  ){
                      this.allDocsStats = parseInt(this.completeDocsStats) + parseInt(this.pendingDocsStats)+ parseInt(this.ignoredDocsStats)+ parseInt(this.failedDocsStats)+ parseInt(this.caseNotFoundDocsStats)
                    }
                }
            }).catch((err)=>{

            })
        },
        changeTab(tab ='ALL'){
            this.page = 1;
            this.selecetedTab = tab;
            this.getStatsCount(tab);
            this.getDetails(tab);
        },
    changeperPage(){
        this.page = 1;
        this.getDetails();
      },
      pageNate(pageNum) {
       
       this.page = pageNum;
       this.getDetails();
     },
    togleExpend(data) {
      const $ = JQuery;
      console.log("togleExpend",)
      $('body').removeClass('widget-expended')
      if (_.has(data, 'columnId') && this.widgetExpended != data['columnId']) {
        this.widgetExpended = data['columnId'];
        $('body').addClass('widget-expended')
      } else {
        this.widgetExpended = '';
      }
    },
    download_or_view(docItem) {
      let value = _.cloneDeep(docItem);
      this.selectedFileForEdit =false;
      this.showCloseIcon = false;
      if ( _.has(value ,'viewmode') && this.checkProperty(value,'viewmode')==false ) {
          this.selectedFileForEdit =true;
      }

      this.expandModal= false;

      if (
        this.checkProperty(this.getPetitionDetails, "caseNo") &&
        this.checkProperty(value, "name")
      ) {
        let docName = _.cloneDeep(value["name"]);
        
        try{
          if(!docName.includes(this.checkProperty(this.getPetitionDetails, "caseNo"))){
            value["name"] = docName;
          }
        }catch(err){

        }

        
      }

      var _self = this;
      this.formSubmited = false;
      if (_.has(value, "path")) {
        value["url"] = value["path"];
        value["document"] = value["path"];
      }

      if (_.has(value, "url")) {
        value["path"] = value["url"];
        value["document"] = value["url"];
      }

      if (_.has(value, "document")) {
        value["path"] = value["document"];
        value["url"] = value["document"];
      }

      this.selectedFile = value;
      this.docValue = "";
      this.docPrivew = false;
      this.docType = false;
      this.docType = this.findmsDoctype(value);
      this.showCloseIcon = false;

      //if ( (this.docType == "office" || this.docType == "image" || this.docType == "pdf") && value.download == false ) {
      if (this.docType == "office" || this.docType == "image" || this.docType == "pdf") {
        value.url = value.url.replace(this.$globalgonfig._S3URL, "");
        value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
        let postdata = {
          keyName: value.url,
          petitionId: value["petitionId"],
        };
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          this.docValue = response.data.result.data;

          if (this.docType == "office") {
            document.getElementById("placeholder").innerHTML =
              "  <div  id='placeholder2' style='height:100%'></div>";
            let _editing = false;

            if ([50, 51].indexOf(this.getUserRoleId) > -1) {
              _editing = false;
            }
           
            let docViewUrl ='https://immibox.com/api/petition/post-edited-document';
            if(_.has(this.$globalgonfig, 'DOC_VIEW_URL')){
              docViewUrl = this.$globalgonfig['DOC_VIEW_URL'];
            }

            let entityId = 'cover_letter';
            if(this.checkProperty(value,'entityId')){
              entityId = value['entityId'];
            }
               
            if ( _.has(value ,'viewmode') && value.viewmode==false ) {
              _editing = true;
              if(_.has(value,'type') && _self.checkProperty(value, 'type') == 'Letter' && _.has(value,'generated') &&
              (_self.checkProperty(value, 'generated') == true || _self.checkProperty(value, 'generated') == 'true') && !value['parentId']
               ){
                this.showCloseIcon = true; 
                // && this.checkProperty( this.$store.state ,'selectedForEditDocument') && this.checkProperty( this.$store.state ,'selectedForEditDocument', 'savedDocumentId')
              } 
            }
            var _ob = {};
            if (value.editedDocument) {
              _ob = {
               // entityId:entityId,
                petitionId: this.petition._id,
                name: value.name,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value.parentId,
              };
            } else {
              _ob = {
               // entityId:entityId,
                name: value.name,
                petitionId: this.petition._id,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value._id,
              };
            }
            var nid = value._id +  Math.round(+new Date()/1000)
            window.docEditor = new DocsAPI.DocEditor("placeholder2", {
              document: {
                c: "forcesave",
                fileType: "docx",
                key: nid,
                userdata: JSON.stringify(_ob),
                title: value.name,
                url: response.data.result.data,
                permissions: {
                  edit: _editing,
                  download: true,
                  reader: false,
                  review: false,
                  comment: false,
                },
              },

              documentType: "word",
              height: "100%",
              width: "100%",

              editorConfig: {
                userdata: JSON.stringify(_ob),
                callbackUrl:
                docViewUrl+"?entityId="+entityId+"&payload=" +
                  JSON.stringify(_ob) +
                  "&token=" +
                  _self.$store.state.token +
                  "&name=" +
                  value.name.replace(".docx", ""),
                customization: {
                  logo: {
                    image: "https://immibox.com/app/favicon.png",
                    imageDark: "https://immibox.com/app/favicon.png",
                    url: "https://immibox.com",
                  },
                  anonymous: {
                    request: false,
                    label: "Guest",
                  },
                  chat: false,
                  comments: false,
                  compactHeader: false,
                  compactToolbar: true,
                  compatibleFeatures: false,
                  feedback: {
                    visible: false,
                  },
                  forcesave: true,
                  help: false,
                  hideNotes: true,
                  hideRightMenu: true,
                  hideRulers: true,
                  layout: {
                    toolbar: {
                      collaboration: false,
                    },
                  },
                  macros: false,
                  macrosMode: "warn",
                  mentionShare: false,
                  plugins: false,
                  spellcheck: false,
                  toolbarHideFileName: true,
                  toolbarNoTabs: true,
                  uiTheme: "theme-light",
                  unit: "cm",
                  zoom: 100,
                },
              },
              events: {
                onReady: function () {},
                onDocumentStateChange: function (event) {
                  var url = event.data;
                  if (!event.data) {
                    if (value.editedDocument) {
                    }
                  }
                },
              },
            });
            //this.docValue = encodeURIComponent(response.data.result.data);
          }

          if (this.docType == "pdf") {
            var formAndLetterId = value._id;
            let parentId = '';
            // if (this.checkProperty(value,'parentId')) {
            //   parentId = value.parentId;
            // }else{
            //   if (this.checkProperty(value,'generated')) {
            //     parentId = value._id;
            //   }
             
            // }
            //alert(parentId)
            var  viewmode = 0; //viewmode= 1 Enable edit AND viewmode= 0; //Disabled Edit
            let pdfViewUrl ='https://immibox.com/viewer/pdfjs-dist/web/viewerv2.html';
            
            if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
              pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
            }
             

            if(_.has(value ,'viewmode')){
              if (value.viewmode) {
                viewmode = 0;
              }else{
                viewmode = 1;
                viewmode=viewmode+"&depLabel="+value.depLabel+"&depType="+value.depType+"&docUserType="+value.docUserType+"&generated="+value.generated+"&parentId="+parentId+"&formAndLetterId="+formAndLetterId+"&save=v2&docname="+value.name+"&posturl="+this.$globalgonfig._APIURL+"/&petitionId="+this.$route.params.itemId+"&entityId="+value.entityId+"&token="+this.$store.state.token
                if(_.has(this.$globalgonfig, 'PDF_EDIT_URL')){
                  pdfViewUrl = this.$globalgonfig['PDF_EDIT_URL'];
                  
                 }
              }

            }

           
            
           
            if(this.getPetitionTab != 'Forms and Letters'){
              viewmode= 0; //Disabled Edit
              if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
                pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
              }
              
            }
           
            this.docValue =
            pdfViewUrl+"?view=" +
              viewmode +
              "+&file=" +
              encodeURIComponent(response.data.result.data);
          }
          this.docPrivew = true;
        });
      } else {
        this.downloads3file(value);
      }
    },
  },
  created() {
 
  },
  mounted() {
 
 
  }
};
 
 
</script>